import { apiInternetBase, HttpType, openLoading } from 'gf-ui'

export class apiConf extends apiInternetBase {

  constructor(dispatch, apiCallback, token){
    super(dispatch, apiCallback, token, "/conf")
  }
  
  #datiUtente               = (token, cb) => this._getJson(HttpType.POST, `/dati-utente` , cb, token);       
  #salvaDatiUtente          = (token, cb) => this._getJson(HttpType.POST, `/salva-dati-utente` , cb, token);       
  #autorizza                = (token, cb) => this._getJson(HttpType.GET,  `/autorizza` , cb, token);       
  #salvaAutocertificazione  = (token, cb) => this._getJson(HttpType.POST, `/salva-autocertificazione` , cb, token);           

  fnDatiUtente = (fnReturn, params) => {
    openLoading(this.dispatch, "Recupero dati utente...")
    this.setParams(params);
    this.#datiUtente(this.token, (status, res) => this.apiCallback(status, res, fnReturn, null, "/logout"))
  }

  fnSalvaDatiUtente = (fnReturn, params) => {
    openLoading(this.dispatch, "Salvataggio dati utente...")
    this.setParams(params);
    this.#salvaDatiUtente(this.token, (status, res) => this.apiCallback(status, res, fnReturn, null, "/logout"))
  }

  fnAutorizza = (fnReturn, fnReturnError) =>{        
      openLoading(this.dispatch);      
      this.#autorizza(this.token, (status, res) => this.apiCallback(status, res, fnReturn, fnReturnError))
  }

  fnSalvaAutocertificazione = (fnReturn, params, fnReturnError) =>{        
      openLoading(this.dispatch);
      this.setParams(params);
      this.#salvaAutocertificazione(this.token, (status, res) => this.apiCallback(status, res, fnReturn, fnReturnError))
  }
}